import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { logout } from './AuthSlice'
const apiURL = process.env.REACT_APP_BACKEND

const initialState = {
  customers: [],
}

export const getCustomers = createAsyncThunk('customer/getCustomers', async (_, thunkAPI) => {
  // access the entire redux state
  const state = thunkAPI.getState()
  const { authId, webToken, subscriberId, customerId } = state.auth

  let custURL;
  if (authId === 100) {
    custURL = 'api/gatecustomersNew/'
  } else if (authId === 1) {
    custURL = 'api/gatecustomersNew/subscriber/' + subscriberId
  } else if (authId === 2 || authId === 4) {
    custURL = 'api/gatecustomersNew/id/' + customerId;
  }
  if (!custURL) return []

  return await fetch( apiURL + custURL, {
    method: 'get',
    headers: { 'Accept': 'application/json', 'Authorization': webToken },
    credentials: 'include'
  })
  .then(response => response.json())
  .then(data => data.rows)
  .catch(error => {
      console.error('Error:', error);
      return []
  })
});

const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    setCustomerState: (state, action) => {
      state[action.payload.field] = action.payload.value
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCustomers.fulfilled, (state, action) => {
        state.customers = action.payload
      })
      .addCase(logout, (state, action) => {
        return { ...initialState }
      })
  },
})

export const { setCustomerState } = customerSlice.actions
export default customerSlice.reducer
